<template>
  <!-- 기공소용 가이드 PDF 다운로드 버튼(공용).
       클릭 시 언어(한국어/中文) 드롭다운이 열리고, 선택하면 텐센트 COS의 버전 파일명 PDF를
       내려받는다(오브젝트가 octet-stream이라 브라우저가 바로 저장한다). 헤더의 앱 언어 전환과는 무관.
       작업지시서 생성 화면·수기 작업지시서 목록 등 여러 화면에서 재사용한다.

       왜 COS인가(영상 버튼과 동일 원리): 가이드 개정 때마다 앱을 재배포하는 낭비를 없앤다 —
       HTML 원본 수정 → PDF 재출력 → COS 버전 업로드 → manifest 갱신이면 끝이고,
       중국 기공소는 상하이 버킷에서 국내망으로 받는다. SPEC-CHINA-WO-GUIDE-SSOT-001. -->
  <a-dropdown
    :trigger="['click']"
    placement="bottomRight"
  >
    <button
      type="button"
      class="guide-dl-btn"
      @click.prevent
    >
      <i class="fa-solid fa-file-arrow-down"></i>
      {{ $t('workorder_guide_download_btn') }}
      <i class="fa-solid fa-chevron-down guide-dl-caret"></i>
    </button>
    <template #overlay>
      <a-menu @click="onMenuClick">
        <a-menu-item key="ko">
          <i class="fa-solid fa-file-pdf guide-dl-ico"></i> 한국어
        </a-menu-item>
        <a-menu-item key="zh">
          <i class="fa-solid fa-file-pdf guide-dl-ico"></i> 中文
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script>
// SSOT 매니페스트를 런타임(COS 포인터)에서 읽는다 — 가이드 개정 시 앱 재배포 불필요.
// (SPEC-CHINA-WO-GUIDE-SSOT-001 v0.4.0, VideoGuideButton과 동일 패턴)
import { getGuideManifest, GUIDE_COS_BASE } from '@/utils/guideManifest';

const DEFAULT_BASE = GUIDE_COS_BASE;

// manifest가 깨져도 버튼은 죽지 않도록 마지막 배포 시점의 키를 폴백으로 유지한다.
const FALLBACK_KEYS = {
  ko: 'pdf/wo-guide-ko-v0.6.pdf',
  zh: 'pdf/wo-guide-zh-v0.6.pdf'
};

export default {
  name: 'GuideDownloadButton',
  methods: {
    // 드롭다운에서 언어 선택 시 호출. key는 'ko' | 'zh'.
    onMenuClick({ key }) {
      this.downloadGuide(key);
    },
    async downloadGuide(lang) {
      const guideManifest = await getGuideManifest();
      const manifestPdf = (guideManifest && guideManifest.artifacts && guideManifest.artifacts.pdf) || {};
      // manifest files 예: ["pdf/wo-guide-ko-v0.6.pdf", ...] — 버전 접미가 바뀌어도 언어 토큰으로 해석.
      const files = Array.isArray(manifestPdf.files) ? manifestPdf.files : [];
      const key = files.find((f) => typeof f === 'string' && f.includes(`wo-guide-${lang}`))
        || FALLBACK_KEYS[lang] || FALLBACK_KEYS.ko;
      const base = (manifestPdf.base || DEFAULT_BASE).replace(/\/$/, '');
      // COS 오브젝트가 application/octet-stream이라 새 탭 없이 바로 저장된다.
      const a = document.createElement('a');
      a.href = `${base}/${key}`;
      a.rel = 'noopener';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
};
</script>

<style scoped lang="scss">
// CertificateWorkOrder '사용법' 버튼(.wo-tour-help-btn)과 동일한 룩으로 통일한다.
$Gray-10: #F1F2F3;
$Gray-30: #DDE0E4;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-80: #4B5158;
$Gray-90: #2F3337;

.guide-dl-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1px solid $Gray-30;
  border-radius: 8px;
  background: #fff;
  color: $Gray-80;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  i {
    font-size: 14px;
    color: $Gray-60;
  }

  &:hover {
    background: $Gray-10;
    border-color: $Gray-50;
    color: $Gray-90;

    i {
      color: $Gray-80;
    }
  }

  // 드롭다운 여닫힘 caret은 본 아이콘보다 작게 표시한다.
  .guide-dl-caret {
    font-size: 10px;
    margin-left: 2px;
  }
}

.guide-dl-ico {
  color: $Gray-60;
  margin-right: 4px;
}
</style>
